// extracted by mini-css-extract-plugin
module.exports = {"section":"QuoteVisualizer_section__22cQQ","plug":"QuoteVisualizer_plug__2tYqI"};